import React, { useState, useEffect } from 'react'

const Clock = (props) => {
    // hours difference
    const [ hoursDifference, setHoursDifference ] = useState(0)
    const [ minutesDifference, setMinutesDifference ] = useState(0)
    const [ daysDifference, setDaysDifference ] = useState(0)
    const [ secondDifference, setSeccondDifference ] = useState(0)

    useEffect( () => {
        if (props.selectedDate) {
            let localDate;
            let localFinalDate
            if (!props.changedSelection) {
                localDate = new Date(props.selectedDate)
                localFinalDate = new Date(localDate.setDate(localDate.getDate() + 2))
                localFinalDate.setHours(0,0,0,0)
                // calculate the difference
                let difference = localFinalDate - props.currentDate

                // calculate the various units
                let seconds = Math.floor(difference / 1000);
                let minutes = Math.floor(seconds / 60);
                let hours = Math.floor(minutes / 60);
                let days = Math.floor(hours / 24);
    
                // divide the units by their params
                hours %= 24;
                minutes %= 60;
                seconds %= 60;
    
                // set them to state
                setHoursDifference(hours)
                setDaysDifference(days)
                setMinutesDifference(minutes)
                setSeccondDifference(seconds)
            } else {
                localDate = new Date(props.selectedDate)
                localFinalDate = localDate.setDate(localDate.getDate() + 2)
            }
            if (props.currentDate < localFinalDate) {
                // calculate the difference
                let difference = localFinalDate - props.currentDate
    
                // calculate the various units
                let seconds = Math.floor(difference / 1000);
                let minutes = Math.floor(seconds / 60);
                let hours = Math.floor(minutes / 60);
                let days = Math.floor(hours / 24);
    
                // divide the units by their params
                hours %= 24;
                minutes %= 60;
                seconds %= 60;
    
                // set them to state
                setHoursDifference(hours)
                setDaysDifference(days)
                setMinutesDifference(minutes)
                setSeccondDifference(seconds)
            } else {
                setHoursDifference(0)
                setDaysDifference(0)
                setMinutesDifference(0)
                setSeccondDifference(0)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentDate])

    return(
        <div className='countdownCLockCountainer'>
            <div className='titleLockBox'>
                <h2>Time Until Lock</h2>
            </div>
                <div className='clockUnitsContainer'>
                    <h3><span className='clockTime'>{daysDifference}</span> days</h3>
                    <h3><span className='clockTime'>{hoursDifference}</span> hours</h3> 
                    <h3><span className='clockTime'>{minutesDifference}</span> minutes</h3> 
                    <h3><span className='clockTime'>{secondDifference}</span> seconds</h3>
                </div>
        </div>
    )
}

export default Clock